import {
	BroadLineOfBusiness,
} from '@app/enumerations';

export default class BroadLineOfBusinessDetails {
	public code: BroadLineOfBusiness | null = null;
	public friendlyName: string | null = null;

	public constructor() {

	}
}